import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const COLORS = ['#3b82f6', '#a78bfa', '#10b981', '#f59e0b', '#f43f5e'];

const DeliveryPersonnel = ({ data }) => {
    const { t } = useTranslation();
    if (!data?.personnel?.length) return null;

    const strings = t('deliveryAnalytics.charts.personnel', { returnObjects: true });

    const personnel = data.personnel;
    const maxDeliveries = Math.max(...personnel.map(p => p.total_deliveries || 0));
    const maxWeight = Math.max(...personnel.map(p => parseFloat(p.total_weight_tons) || 0));

    return (
        <div style={cardStyle}>
            <div style={headerStyle}>
                <div>
                    <span style={titleStyle}>{strings.title}</span>
                    <div style={subtitleStyle}>{strings.subtitle}</div>
                </div>
                <span style={badgeStyle}>{t('deliveryAnalytics.charts.personnel.supervisorsCount', { count: personnel.length })}</span>
            </div>

            <div style={{ padding: '12px 20px 20px', display: 'flex', flexDirection: 'column', gap: 20 }}>
                {personnel.map((person, i) => {
                    const color = COLORS[i % COLORS.length];
                    const deliveryPct = maxDeliveries > 0 ? (person.total_deliveries / maxDeliveries) * 100 : 0;
                    const weightPct = maxWeight > 0 ? (parseFloat(person.total_weight_tons) / maxWeight) * 100 : 0;
                    return (
                        <div key={person.user_id} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                            {/* Name + Role */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                <div style={{
                                    width: 36, height: 36, borderRadius: 10,
                                    backgroundColor: `${color}18`,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    color, fontSize: 14, flexShrink: 0
                                }}>
                                    <FontAwesomeIcon icon={faUserTie} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>{person.name}</div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 }}>
                                        <span style={{
                                            fontSize: 11, fontWeight: 600, color,
                                            backgroundColor: `${color}18`, borderRadius: 6, padding: '1px 7px',
                                            textTransform: 'capitalize'
                                        }}>
                                            {person.role?.replace(/_/g, ' ')}
                                        </span>
                                    </div>
                                </div>
                                <div style={{ textAlign: 'right' }}>
                                    <div style={{ fontSize: 13, color: '#9ca3af' }}>{strings.avgPerDelivery}</div>
                                    <div style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>
                                        {parseFloat(person.average_weight_per_delivery_tons || 0).toFixed(3)} {strings.tonSuffix}
                                    </div>
                                </div>
                            </div>

                            {/* Bars */}
                            <div style={{ display: 'flex', gap: 16 }}>
                                <div style={{ flex: 1 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                        <span style={{ fontSize: 11, color: '#6b7280' }}>{strings.deliveries}</span>
                                        <span style={{ fontSize: 12, fontWeight: 700, color }}>{person.total_deliveries}</span>
                                    </div>
                                    <div style={{ height: 5, borderRadius: 3, backgroundColor: '#e5e7eb' }}>
                                        <div style={{ height: '100%', borderRadius: 3, backgroundColor: color, width: `${deliveryPct}%`, transition: 'width 0.5s' }} />
                                    </div>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                        <span style={{ fontSize: 11, color: '#6b7280' }}>{strings.weight}</span>
                                        <span style={{ fontSize: 12, fontWeight: 700, color }}>
                                            {parseFloat(person.total_weight_tons || 0).toFixed(2)} {strings.tonSuffix}
                                        </span>
                                    </div>
                                    <div style={{ height: 5, borderRadius: 3, backgroundColor: '#e5e7eb' }}>
                                        <div style={{ height: '100%', borderRadius: 3, backgroundColor: color, width: `${weightPct}%`, transition: 'width 0.5s' }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const cardStyle = { backgroundColor: '#fff', borderRadius: 16, border: '1px solid #f3f4f6', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', overflow: 'hidden', height: '100%' };
const headerStyle = { padding: '18px 20px 14px', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' };
const titleStyle = { fontSize: 15, fontWeight: 700, color: '#111827', display: 'block' };
const subtitleStyle = { fontSize: 12, color: '#9ca3af', marginTop: 2 };
const badgeStyle = { fontSize: 11, fontWeight: 700, color: '#0891b2', backgroundColor: '#ecfeff', borderRadius: 20, padding: '3px 10px' };

export default DeliveryPersonnel;
